/**
 * Belabelly — política de estoque: tudo é fabricável, nunca "Esgotado" na vitrine/PDP.
 * Pronta entrega (metafield custom.pronta_entrega): FULL com estoque; prazo de fabricação sem estoque.
 */
(function (global) {
  'use strict';

  /**
   * @param {HTMLElement | null} meta
   * @param {{ available?: boolean } | null | undefined} variant
   * @returns {{ text: string, inStockGreen: boolean, isProduction: boolean }}
   */
  function stockMetaDisplay(meta, variant) {
    if (!meta) return { text: '', inStockGreen: false, isProduction: false };

    var available = !variant || variant.available !== false;

    if (meta.hasAttribute('data-production-full') && available) {
      return {
        text: meta.dataset.fullTag || '',
        inStockGreen: true,
        isProduction: false,
      };
    }

    if (meta.hasAttribute('data-md-production')) {
      return {
        text: meta.dataset.productionText || '',
        inStockGreen: false,
        isProduction: true,
      };
    }

    return {
      text: meta.dataset.fallbackInStock || '',
      inStockGreen: available,
      isProduction: false,
    };
  }

  /**
   * @param {HTMLElement | null} meta
   * @param {{ available?: boolean } | null | undefined} variant
   */
  function applyStockMeta(meta, variant) {
    if (!meta) return;
    var display = stockMetaDisplay(meta, variant);
    meta.textContent = display.text;
    meta.classList.toggle('md-pdp__meta--in-stock', display.inStockGreen);
    meta.classList.toggle('md-pdp__meta-production', display.isProduction);
  }

  global.BelabellyInventoryPolicy = {
    alwaysPurchasable: true,
    stockMetaDisplay: stockMetaDisplay,
    applyStockMeta: applyStockMeta,
  };
})(window);
